export const USER_COHORT = {
    d2c: 'd2c',
    pvolve: 'pvolve',
};

export const ENTITLEMENT_SOURCE = {
    optum: 'optum',
};

export const getUserCohortsString = () => {
    return Object.values(USER_COHORT).reduce((prev: string, current: string) => {
        return `${prev},cohort${current}`
    }, '');
}
